var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJobs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-navigation-Icons/Active/Jobs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    className: "svg-path1",
    fillOpacity: 0.5,
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Selector",
    className: "svg-path2",
    fillOpacity: 0.8,
    points: "0 0 6 0 6 50 0 50"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-path3",
    fillOpacity: 0.8,
    d: "M24.5263158,15 C26.1381579,15 27.4539474,16.1333333 27.75,17.6666667 L27.75,17.6666667 L35.0526316,17.6666667 L35.0526316,35 L14,35 L14,17.6666667 L21.3026316,17.6666667 C21.5986842,16.1333333 22.9144737,15 24.5263158,15 Z M33.7368421,28.8333333 L15.3157895,28.8333333 L15.3157895,33.6666667 L33.7368421,33.6666667 L33.7368421,28.8333333 Z M33.7368421,19 L15.3157895,19 L15.3157895,27.5 L33.7368421,27.5 L33.7368421,19 Z M24.5263158,24.5333333 C25.0168319,24.5333333 25.4144737,24.9362771 25.4144737,25.4333333 C25.4144737,25.9303896 25.0168319,26.3333333 24.5263158,26.3333333 C24.0357997,26.3333333 23.6381579,25.9303896 23.6381579,25.4333333 C23.6381579,24.9362771 24.0357997,24.5333333 24.5263158,24.5333333 Z M24.5263158,16.3333333 C23.6381579,16.3333333 22.9144737,16.9 22.6513158,17.6666667 L22.6513158,17.6666667 L26.4013158,17.6666667 C26.1381579,16.8666667 25.4144737,16.3333333 24.5263158,16.3333333 Z",
    id: "Jobs"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobs);
export default __webpack_public_path__ + "static/media/jobs.7de34c6f4251dc5303cce2f7cdaa8d3a.svg";
export { ForwardRef as ReactComponent };